import { OutlinedInput } from "@mui/material";
import React from "react";
import { formatNumber } from "../../libs/helpers";


const InputCell: React.FC<InputCellProps> = (props: InputCellProps) => {
  const { isConfirmed, value, type, onChangeText, textAlignment = "center", zeroVisible: isWrappingSize = false } = props;
  const [focusing, setFocusing] = React.useState<boolean>(false);

  const displayValue = React.useMemo(() => {
    if (type === "number") {
      if (value === 0) {
        return "-";
      } else {
        return formatNumber(Number(value))
      }
    } else {
      return value;
    }
  }, [type, value]);

  return (
    <div style={{display: "flex", justifyContent: textAlignment === "left" ? "flex-start" : textAlignment === "right" ? "flex-end" : "center"}}>
      {
        isConfirmed ? 
          <span style={{textAlign: textAlignment, padding: "5px 0", cursor: "pointer"}}>{displayValue}</span> :
          <OutlinedInput
            type={type}
            color="primary"
            value={type === "number" && value === 0 && !isWrappingSize ? "" : value}
            onChange={(e) => onChangeText(e.target.value)}
            onBlur={() => setFocusing(false)}
            onFocus={(e) => setFocusing(true)}
            sx={{
              border: focusing ? "" : "none",
              backgroundColor: !focusing ? "transparent" : "#fff",
              "& input" : {
                textAlign: textAlignment
              }
            }}
          />
      }
    </div>
  )
}

export default InputCell;

export type InputCellProps = {
  isConfirmed: boolean;
  value: string | number;
  onChangeText: (val: string | number) => void;
  type: "text" | "number";
  textAlignment?: "right" | "center" |"left";
  zeroVisible?: boolean
}